export const getDate = (date: string) => {
  const parsedDate = new Date(date);
  return `${('00' + parsedDate.getDate()).slice(-2)}.${('00' + (parsedDate.getMonth() + 1)).slice(-2)}.${parsedDate.getFullYear()}`;
};
